import { useCallback, useRef, useState, useContext, useEffect } from 'react';
import Common from '../../shared/Common';
import type { IIncome } from '../../../interfaces/IIncome';
import { DictionaryContext } from '../../../App';
import IncomeModal from './IncomeModal';

import './style.css';

export interface IIncomeProps {
  show: boolean;
  onHide: () => void;
  onIncomeAdd: () => void;
  onIncomeSave: (income: IIncome) => void;
  onIncomeRemove: (incomeId: number) => void;
  incomeId: number;
}

const Income = (props: IIncomeProps) => {
  const [copyMode, setCopyMode] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [initialLoading, setInitialLoading] = useState<boolean>(false);
  const fetchIncomedRef = useRef(0);
  const { incomeCategories, incomeQuantityTypes, locationNames } = useContext(DictionaryContext);
  const [income, setIncome] = useState<IIncome>({
    incomeId: 0,
    location: {
      locationId: -1,
      locationName: '',
      picture: '',
      mappings: [],
    },
    category: incomeCategories.length > 0 ? incomeCategories[0] : undefined,
    quantityType: {
      incomeQuantityTypeId: 1,
      incomeQuantityTypeShortName: 'szt.',
      incomeQuantityTypeName: 'Sztuk',
    },
    description: '',
    revenue: 0,
    quantity: 1,
    time: new Date(),
  });

  useEffect(() => {
    if (incomeCategories.length > 0) {
      setIncome((prevIncome) => ({
        ...prevIncome,
        category: incomeCategories[0],
      }));
    }
  }, [incomeCategories]);

  const hideModal = () => {
    props.onHide();
    setIncome({
      incomeId: 0,
      location: {
        locationId: -1,
        locationName: '',
        picture: '',
        mappings: [],
      },
      category: incomeCategories.length > 0 ? incomeCategories[0] : undefined,
      quantityType: {
        incomeQuantityTypeId: 1,
        incomeQuantityTypeShortName: 'szt.',
        incomeQuantityTypeName: 'Sztuk',
      },
      description: '',
      revenue: 0,
      quantity: 1,
      time: new Date(),
    });
    setCopyMode(false);
    setLoading(false);
    setInitialLoading(false);
  };

  const fetchIncome = useCallback(async (IncomeId: number) => {
    if (IncomeId !== 0) {
      setLoading(true);
      setInitialLoading(true);
      const fetchId = ++fetchIncomedRef.current;

      const response = await Common.authorizedFetch('api/incomes/getIncome?IncomeId=' + IncomeId);
      if (fetchId === fetchIncomedRef.current) {
        const data = await response.json();
        if (data.success) {
          var income = data.result.income as IIncome;
          if (!income.location) {
            income.location = {
              locationId: -1,
              locationName: '',
              picture: '',
              mappings: [],
            };
          }
          setIncome(income);
        }
        setInitialLoading(false);
      }
      setLoading(false);
    }
  }, []);

  return (
    <div>
      <IncomeModal
        show={props.show}
        onHide={hideModal}
        onIncomeAdd={props.onIncomeAdd}
        onIncomeSave={props.onIncomeSave}
        onIncomeRemove={props.onIncomeRemove}
        fetchIncome={fetchIncome}
        income={income}
        incomeQuantityTypes={incomeQuantityTypes}
        incomeCategories={incomeCategories}
        locationNames={locationNames}
        setIncome={setIncome}
        incomeId={props.incomeId}
        copyMode={copyMode}
        setCopyMode={setCopyMode}
        loading={loading}
        setLoading={setLoading}
        initialLoading={initialLoading}
      />
    </div>
  );
};

export default Income;
